<script setup>
import FixPanel from "@/components/approval-center/partials/ui/FixPanel.vue";
import FixPanelHeader from "@/components/approval-center/partials/ui/FixPanelHeader.vue";
import FixPanelHeaderTitle from "@/components/approval-center/partials/ui/FixPanelHeaderTitle.vue";
import MoveGroupTransition from "@/components/transitions/MoveGroupTransition.vue";
import FixPanelIcon from "@/components/approval-center/partials/ui/FixPanelIcon.vue";
import FixContent from "@/components/approval-center/partials/ui/FixContent.vue";
import FixText from "@/components/approval-center/partials/ui/FixText.vue";
import {computed} from "vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import SuccessFlow from "@/components/approval-center/modals/SuccessFlow.vue";
import RevisionFlow from "@/components/approval-center/modals/RevisionFlow.vue";
import {useApprovals} from "@/composables/approval-center/useApprovals";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import FixPanelSubText from "@/components/approval-center/partials/ui/FixPanelSubText.vue";
import FixPanelFooter from "@/components/approval-center/partials/ui/FixPanelFooter.vue";

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
});

const {
  showSuccessFlow,
  selectedApproval,
  handleConfirmMutation,
  handleClose,
  selectApprovalForApprove,
  selectApprovalForRevision,
  showRevisionFlow,
  revisionText,
  handleConfirmRevisionMutation,
} = useApprovalFlow();

const {mutate: handleConfirm} = handleConfirmMutation();
const {mutate: handleRevisionMutate, isPending: isRevisionPending} = handleConfirmRevisionMutation();

const {approvals, isPending} = useApprovals(props.category);

const approval = computed(() => approvals.value[0] || undefined);

</script>

<template>
  <FixPanel v-if="approval || isPending">
    <FixPanelHeader class="tw-flex-col !tw-items-start">
      <FixPanelHeaderTitle>Tone-of-Voice</FixPanelHeaderTitle>
      <FixPanelSubText>I’ve created this guide to ensure all future content I create reflects your brand’s style, please review and approve.</FixPanelSubText>
    </FixPanelHeader>

    <LoadingBlock v-if="isPending" />

    <MoveGroupTransition
      v-else
      class="tw-space-y-8"
    >
      <FixPanel>
        <FixPanelHeader>
          <FixPanelIcon icon-path="icons/playbook" />
          <FixPanelHeaderTitle>Playbook</FixPanelHeaderTitle>
        </FixPanelHeader>

        <FixContent class="tw-max-h-[480px] tw-prose tw-max-w-none tw-flex tw-items-start tw-gap-8">
          <KitIcon />

          <FixText>
            <div v-html="approval.approvable.tone_of_voice" />
          </FixText>
        </FixContent>

        <FixPanelFooter
          :approval="approval"
          :category="category"
          @approve="selectApprovalForApprove(approval)"
          @revise="selectApprovalForRevision(approval)"
        />
      </FixPanel>
    </MoveGroupTransition>
  </FixPanel>
  <SuccessFlow
    v-if="showSuccessFlow"
    @confirm="handleConfirm({
      approval: selectedApproval,
      category,
    })"
    @close="handleClose"
  />
  <RevisionFlow
    v-if="showRevisionFlow"
    v-model:feedback="revisionText"
    :loading="isRevisionPending"
    @confirm="handleRevisionMutate({
      approval: selectedApproval,
      feedback: revisionText,
      category,
    })"
    @close="handleClose"
    @continue="handleClose"
  />
</template>
